import { supabase } from '@/integrations/supabase/client';

/**
 * Diagnóstico de pedido paralelo: grava em `events.creation_origin` POR QUE a loja criou um pedido novo (modo proposta, se já havia
 * pedido de proposta na sessão, se o link trazia ref/pid, se veio da recriação depois de "nenhuma linha atualizada" e a primeira rota da URL).
 * Não leva dados do cliente nem valores da URL. Quando aparecer outra cópia (ex.: 18 s depois da proposta), o campo mostra qual caminho a criou.
 */
export interface CreationOriginContext {
  quoteMode: boolean;
  sharedParentInSession: boolean;
  urlHasRef: boolean;
  afterNoRows: boolean;
  firstPathSegment: string;
}

export const describeCreationOrigin = (ctx: CreationOriginContext): string =>
  [
    `quote=${ctx.quoteMode ? 1 : 0}`,
    `shared_parent=${ctx.sharedParentInSession ? 1 : 0}`,
    `url_ref=${ctx.urlHasRef ? 1 : 0}`,
    `retry=${ctx.afterNoRows ? 'no_rows' : 'first'}`,
    `path=/${ctx.firstPathSegment.replace(/[^a-z0-9_-]/gi, '').slice(0, 24)}`,
  ].join(';');

/** Grava a origem logo depois do INSERT. Complemento: se a coluna ainda não existe ou a escrita falha, a loja segue normalmente. */
export async function recordCreationOrigin(eventId: string, ctx: CreationOriginContext): Promise<void> {
  try {
    await (supabase as any).from('events').update({ creation_origin: describeCreationOrigin(ctx) }).eq('id', eventId);
  } catch {
    /* diagnóstico nunca atrapalha */
  }
}
